const state = {
    users: [],
    simulatableUsers: [],
}

const getters = {
    usersSortedByUsername(state) {
        return [...state.users].sort((a, b) =>
            a.username.localeCompare(b.username, undefined, {
                numeric: true,
            })
        )
    },
    simulatableUsersSortedByUsername(state) {
        return [...state.simulatableUsers].sort((a, b) =>
            a.username.localeCompare(b.username, undefined, {
                numeric: true,
            })
        )
    },
}

const actions = {}

const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
